import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import CheckIcon from '../../../../assets/images/check.png';
import FollowUser from '../../FollowUser';
import ReactTimeAgo from 'react-time-ago';
import AppContext from 'components/app_context';
import { validURL } from 'lib';
import { DOMAIN } from 'constants';
import PintopIcon from '../../../../assets/images/pin-top.png';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import ModalConfirmDelete from 'components/shared/modalDeleteConfirmComment/modal';
import { toastError } from 'helpers/toastHelper';
import './PostHeader.css';

const PostHeader = ({
  post,
  isOwner,
  current_user,
  handleFollowPost,
  handleUnFollowPost,
  meta,
  actionReportPost,
  actionDelete,
  modifyDataDelete,
}) => {
  const { isMobile } = useContext(AppContext);
  let shop_image = validURL(post.shop_image) ? `${post.shop_image}` : `${DOMAIN}${post.shop_image}`;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let [report, setReport] = useState('');

  const submitReport = (id, reason) => {
    if (reason === '') {
      toastError('Vui lòng nhập nội dung báo cáo');
    } else {
      actionReportPost(id, reason);
      setShow(false);
      setReport('');
    }
  };

  const renderExpert = () => {
    return (
      <div className="member_rate_in_month d-inline-block w-100 mt-1 ">
        <span className="member_rate icon-start-arrow fs-7 me-1"></span>
        <span className="member_rate_text">{post?.user_role_type === 'expert' ? 'Chuyên gia' : post.member_rate}</span>
      </div>
    );
  };

  return (
    <div className="row">
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-7 col-2xs-12">
        <div className="wrap-flwing" style={{ width: 'maxContent' }}>
          <div className="user-name d-flex align-items-center">
            <Link
              to={`/thanh-vien/${post?.user_slug?.toString() === 'null' ? post?.user_id : post?.user_slug}`}
              className="txt-limit fw-semibold fs-6"
            >
              {post.shop_name === null ? post.user_name : post?.shop_name}
            </Link>
            <span className="tooltip-wrapper">
              <img
                src={post?.user_role_type === 'expert' ? CheckIcon : post.user_level_icon}
                alt="done"
                className="avatar-icon"
              />
              <span className="tooltip-text">
                {post?.user_role_type === 'expert' ? (
                  <strong>Chuyên gia</strong>
                ) : (
                  <>
                    <strong>{post.user_level}</strong>
                    <p style={{ marginBottom: '0' }}>{post.user_level_description}</p>
                  </>
                )}
              </span>
            </span>
            <span className="d-inline-block">{current_user && <FollowUser post={post} isOwner={isOwner} />}</span>
          </div>
          <Link
            to={`/thanh-vien/${post?.user_slug?.toString() === 'null' ? post?.user_id : post?.user_slug}`}
            className="user-inf d-flex"
          >
            <div className="d-flex mt-1">
              <img src={post.shop_image ? shop_image : '/images/avatar.png'} alt="comment images" />
              <div className="txt-sectn">
                <p className="post-time">
                  <span className="icon-location01" /> <span>{post?.province_name ?? 'Không xác định'}</span>
                </p>
                <p className="post-time">
                  <span className="icon-time align-middle"></span>{' '}
                  {post.updated_at && <ReactTimeAgo date={new Date(post.updated_at)} />}
                </p>
                {isMobile && renderExpert()}
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-5 col-2xs-12 d-flex text-end position-relative">
        {!isMobile && renderExpert()}
        <div className="pin_droplist d-flex">
          {post.pin_top === 1 && (
            <div className=" mt-1 ml-1 pin-icon">
              <img src={PintopIcon} alt="icon-pin" />
            </div>
          )}
          <div className="dropdown post-report">
            <>
              <Dropdown>
                <Dropdown.Toggle as="button" className="btn dropdown-toggle">
                  <span className="icon-menu-dot" />
                </Dropdown.Toggle>
                <Dropdown.Menu as="ul" className="dropdown-menu dropdown-menu-end">
                  {!isOwner && current_user ? (
                    !post.user_followed ? (
                      <li
                        onClick={() => handleFollowPost(post.classable_type, post.classable_id)}
                        className="dropdown-item"
                      >
                        <a role="button">Theo dõi bài viết</a>
                      </li>
                    ) : (
                      <li
                        onClick={() => handleUnFollowPost(post.classable_type, post.classable_id)}
                        className="dropdown-item"
                      >
                        <a role="button">Bỏ theo dõi</a>
                      </li>
                    )
                  ) : (
                    ''
                  )}
                  <Link to={`/tin/${post.id}`} className="dropdown-item">
                    <li>
                      <span> Xem chi tiết</span>
                    </li>
                  </Link>

                  {isOwner || current_user?.manager_type == 'admin' ? (
                    <li className="dropdown-item">
                      <a role="button" onClick={() => modifyDataDelete(post.id)}>
                        Xóa bài viết
                      </a>
                    </li>
                  ) : (
                    ''
                  )}
                  {meta?.deleteData != null && (
                    <ModalConfirmDelete
                      onDelete={() => actionDelete(post.id)}
                      isOpen={meta.deleteData}
                      onToggle={() => modifyDataDelete(null)}
                    />
                  )}

                  {!isOwner && current_user && (
                    <li className="dropdown-item">
                      <a href="#" onClick={handleShow}>
                        Báo vi phạm
                      </a>
                    </li>
                  )}
                </Dropdown.Menu>
              </Dropdown>
              <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                  <Modal.Title>Báo vi phạm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <input
                    className="form-control"
                    name="message"
                    placeholder="Nhập lý do"
                    value={report}
                    onChange={e => setReport(e.target.value)}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <button type="button" className="btn btn-primary" onClick={() => submitReport(post.id, report)}>
                    {' '}
                    gửi
                  </button>
                </Modal.Footer>
              </Modal>
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostHeader;
